import * as React from "react";
import {
    Skeleton,
    SkeletonItem,
    makeStyles,
    tokens,
} from "@fluentui/react-components";
import type { SkeletonProps } from "@fluentui/react-components";

const useStyles = makeStyles({
    invertedWrapper: {
        backgroundColor: tokens.colorNeutralBackground1,
        paddingTop: "50px",
        paddingBottom: "50px",
        padding: "20px"
    }
});

export const FormSkeleton = (props: Partial<SkeletonProps>) => {
    const styles = useStyles();

    return (
        <div className={styles.invertedWrapper}>
            <Skeleton {...props} aria-label="Loading Content">
            <SkeletonItem />
            </Skeleton>
        </div>
    );
};